var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5C27.665 0.5 35.5 8.33502 35.5 18Z",
    fill: "white",
    stroke: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.932 18.2045C26.932 17.5663 26.8746 16.9507 26.7655 16.3633H18.147V19.8424H23.0735C22.8611 20.9664 22.218 21.9209 21.2476 22.5591V24.8183H24.2047C25.933 23.2538 26.932 20.9438 26.932 18.2045Z",
    fill: "#3E82F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1462 27.0025C20.6152 27.0025 22.688 26.1948 24.2038 24.8224L21.2468 22.5632C20.4257 23.1054 19.3807 23.4217 18.1462 23.4217C15.7633 23.4217 13.748 21.8402 13.0245 19.7109H9.96985V22.0436C11.4742 24.9862 14.569 27.0025 18.1462 27.0025Z",
    fill: "#32A753"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.025 19.7067C12.8413 19.1645 12.7379 18.5884 12.7379 17.9953C12.7379 17.4023 12.8413 16.8262 13.025 16.284V13.957H9.97037C9.35025 15.1713 9 16.5438 9 18.001C9 19.4525 9.35599 20.825 9.97037 22.045L13.025 19.7067Z",
    fill: "#F9BB00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1462 12.5808C19.4898 12.5808 20.6956 13.0327 21.643 13.925L24.267 11.3439C22.6822 9.89238 20.6094 9 18.1462 9C14.569 9 11.4742 11.0163 9.96985 13.9589L13.0245 16.2916C13.748 14.1623 15.7633 12.5808 18.1462 12.5808Z",
    fill: "#E74133"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogleIcon);
export default __webpack_public_path__ + "static/media/ic-google_icon.f2cf14638f823205e676546e8cc93b56.svg";
export { ForwardRef as ReactComponent };